import smartQueue from './smartQueue';
import Log from '@/Utils/Log';
import ServerTimeProvider from '@/Utils/ServerTimeProvider';
import Config from '@/Config';

function preparePayload(payload) {
    const { projectContext = {} } = payload;

    const preparedPayload = {
        event: payload.event,
        properties: payload.properties,
        timestamp: ServerTimeProvider.now(),
    };

    const { project, creator } = projectContext;

    if (project && creator) {
        preparedPayload['ProjectID'] =  project.projectID;
        preparedPayload['ProjectOriginalType'] =  project.originalType;
        preparedPayload['ProjectPhase'] = project.phase;
        preparedPayload['ProjectType'] =  project.type;
        preparedPayload['ProjectUrlName'] =  project.urlName;
        preparedPayload['ProjectVersion'] =  project.version;
        preparedPayload['CreatorID'] =  creator.creatorID;
        preparedPayload['CreatorUrlName'] =  creator.urlName;
    }

    return preparedPayload;
}

function analyticsPlugin(pluginConfig = {}) {
    const options = {
        max: 50,
        interval: 5 * 1000,
        throttle: false,
    };

    const queue = smartQueue((items, restOfQueue) => {
        if (items.length < 1) {
            return;
        }

        try {
            window.fetch('/api/a/t', {
                method: 'POST',
                body: JSON.stringify(items),
                keepalive: true,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            });
        }
        catch {}
    }, options);

    window.onunload = function() {
        try {
            queue.flush(true);
        }
        catch (error)  {
            Log.warn(error.message);
        }
    };

    return {
        name: `${Config.platformName.toLowerCase()}-plugin`,
        config: pluginConfig,
        track: (event) => {
            try {
                queue.push(preparePayload(event));
            }
            catch (error)  {
                Log.warn(error.message);
            }
        },
    };
}

export default analyticsPlugin;